import React from 'react';
import { trackAddToCart } from '../hooks/useMetaPixel';
import { useCountdown } from '../hooks/useCountdown';
export function PricingSection() {
  const {
    formattedTime,
    isExpired
  } = useCountdown(undefined, 900);
  return <section className="my-16 pt-8 border-t border-[#1a1a1a]" id="get-the-method" data-id="element-217">
      <div className="text-center max-w-[480px] mx-auto" data-id="element-218">
        <h2 className="text-[28px] font-bold text-[#1a1a1a] mb-4 font-serif" data-id="element-219">
          Ready to Start?
        </h2>
        <p className="text-[16px] text-[#4a4a4a] mb-8 font-serif" data-id="element-220">
          Join thousands of others who have reclaimed their mobility. Instant
          digital access.
        </p>

        <div className="bg-[#F9F7F4] p-8 rounded-sm border border-[#E5E5E0]" data-id="element-221">
          {/* Urgency notice — editorial tone */}
          <div className="mb-5 pb-5 border-b border-[#E5E5E0]" data-id="element-222">
            <p className="text-[11px] uppercase tracking-widest text-[#8B2500] font-sans font-bold mb-2" data-id="element-223">
              Reader-exclusive pricing
            </p>
            <p className="text-[13px] text-[#4a4a4a] font-sans leading-relaxed" data-id="element-224">
              This introductory rate of{' '}
              <strong className="text-[#1a1a1a]" data-id="element-225">$6.99</strong> is available for
              a limited time. After this window, the guide returns to its
              regular price of $19.99.
            </p>
            {!isExpired && <div className="mt-3 inline-flex items-center gap-2 bg-[#1a1a1a]/5 px-3 py-1.5 rounded-sm" data-id="element-226">
                <span className="text-[10px] text-[#666] font-sans uppercase tracking-wider" data-id="element-227">
                  Offer expires in
                </span>
                <span className="text-[13px] font-bold text-[#8B2500] font-sans tabular-nums tracking-wide" data-id="element-228">
                  {formattedTime}
                </span>
              </div>}
          </div>

          <div className="flex items-baseline justify-center gap-3 mb-6" data-id="element-229">
            <span className="text-[16px] text-[#888] line-through font-sans" data-id="element-230">
              $19.99
            </span>
            <span className="text-[32px] font-bold text-[#1a1a1a] font-sans" data-id="element-231">
              $6.99 USD
            </span>
          </div>

          <a href="https://oriammarketing.com/cart/45536364036294:1" onClick={e => {
          trackAddToCart();
        }} className="block w-full bg-[#8B2500] text-white font-sans font-bold text-[16px] uppercase tracking-wide px-8 py-4 rounded-sm hover:bg-[#6d1d00] transition-colors text-center no-underline mb-4" data-id="element-232">
            Download Now
          </a>

          <p className="text-[11px] text-[#666] font-sans mb-6" data-id="element-233">
            7-day satisfaction guarantee. Secure payment. Instant delivery.
          </p>

          <div className="flex justify-center gap-2 opacity-60 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-234">
            {/* Visa */}
            <div className="bg-white border border-gray-200 rounded-[2px] px-2 py-1 h-[24px] w-[38px] flex items-center justify-center" data-id="element-235">
              <svg viewBox="0 0 48 32" className="h-[14px]" fill="none" data-id="element-236">
                <rect width="48" height="32" rx="4" fill="#fff" data-id="element-237" />
                <path d="M19.5 21h-3l1.9-11.5h3L19.5 21zm12.3-11.2c-.6-.2-1.5-.5-2.7-.5-3 0-5.1 1.5-5.1 3.7 0 1.6 1.5 2.5 2.6 3.1 1.2.6 1.6.9 1.6 1.4 0 .8-.9 1.1-1.8 1.1-1.2 0-1.9-.2-2.9-.6l-.4-.2-.4 2.5c.7.3 2.1.6 3.5.6 3.2 0 5.2-1.5 5.2-3.8 0-1.3-.8-2.2-2.5-3-1-.5-1.7-.9-1.7-1.4 0-.5.5-1 1.7-1 1 0 1.7.2 2.2.4l.3.1.4-2.4zm7.9-.3h-2.3c-.7 0-1.3.2-1.6.9L31.5 21h3.2l.6-1.7h3.9l.4 1.7H42L39.7 9.5zm-3.3 8.2l1.2-3.2.4-1.1.2 1 .7 3.3h-2.5zM16.2 9.5L13.3 17l-.3-1.5c-.5-1.8-2.2-3.8-4.1-4.8l2.7 10.2h3.2l4.8-11.4h-3.4z" fill="#1A1F71" data-id="element-238" />
                <path d="M10.5 9.5H5.6l-.1.3c3.8.9 6.3 3.2 7.3 5.9l-1.1-5.3c-.2-.7-.7-.9-1.2-.9z" fill="#F9A533" data-id="element-239" />
              </svg>
            </div>
            {/* Mastercard */}
            <div className="bg-white border border-gray-200 rounded-[2px] px-2 py-1 h-[24px] w-[38px] flex items-center justify-center" data-id="element-240">
              <svg viewBox="0 0 48 32" className="h-[14px]" fill="none" data-id="element-241">
                <circle cx="19" cy="16" r="9" fill="#EB001B" data-id="element-242" />
                <circle cx="29" cy="16" r="9" fill="#F79E1B" data-id="element-243" />
                <path d="M24 9.3a9 9 0 0 1 3.3 6.7A9 9 0 0 1 24 22.7 9 9 0 0 1 20.7 16 9 9 0 0 1 24 9.3z" fill="#FF5F00" data-id="element-244" />
              </svg>
            </div>
            {/* PayPal */}
            <div className="bg-white border border-gray-200 rounded-[2px] px-2 py-1 h-[24px] w-[38px] flex items-center justify-center" data-id="element-245">
              <svg viewBox="0 0 48 32" className="h-[12px]" fill="none" data-id="element-246">
                <path d="M17.5 25.5h-3.2l.2-1.2 2-12.8h4.8c2.5 0 4 1.3 3.6 3.5-.5 2.8-2.7 4.3-5.3 4.3h-1.8l-.3 1.7v.2l-.6 3.5-.1.5-.1.3zm3.2-12l-1.4 8.5h1.3c1.8 0 3.3-1 3.6-3 .3-1.5-.5-2.5-2.2-2.5h-1.3z" fill="#003087" data-id="element-247" />
                <path d="M30.5 14.5c-.4 2.8-2.7 4.3-5.3 4.3h-1.3l-.8 5.2-.1.5h-2.5l.1-.5.1-.5.8-5.2h1.3c2.6 0 4.9-1.5 5.3-4.3.1-.5.1-1 0-1.5.5.5.7 1.2.4 2z" fill="#0070E0" data-id="element-248" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>;
}